const validate = (values, t) => {
  const errors = {};
  if (!values.title) {
    errors.title = t('validate.empty-field');
  }

  if (!values.description) {
    errors.description = t('validate.empty-field');
  }
  if (!values.type) {
    errors.type = t('validate.empty-field');
  }
  return errors;
};

export default validate;
